import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/esm/objectWithoutPropertiesLoose';
import _createClass from '@babel/runtime/helpers/esm/createClass';
var _excluded = ['tag'],
    _excluded2 = ['data'];

/* eslint-disable */
import moment from 'moment';
import { defaultsDeep } from 'lodash';
var defaultEmptyAlert = {
  ownerId: null,
  title: 'New Alert',
  story: '',
  type: 'incident',
  severity: 'high',
  rollups: 'medium',
  anomalyAlert: true,
  staticAlert: false,
  noDataAlert: false,
  isInfluencingEvents: false,
  notifyOnlyOpen: false,
  origin: null,
  channels: [],
  contacts: [],
  subscribers: [],
  dynamicRouting: null,
  alertActions: [],
  primaryAlertAction: null,
  pauseTime: null,
  paused: false,
  connectedTiles: null,
  alertTags: null,
  noDataDuration: null,
  eventsFilter: null,
  conditions: null,
  updatePolicy: null,
  expressionTreeModel: null,
  id: null,
  triggerCount: null,
  creationTime: moment().unix(),
  lastModifiedTime: moment().unix(),
  validation: null
};
var tagProperties = ['owner', 'ownerId', 'pausedTime', 'pausedBy', 'pausedId', 'modifiedBy', 'modifierId', 'subscribers', 'extraEmails', 'advancedModeOpen'];
var dataProperties = ['ownerId', 'title', 'story', 'type', 'severity', 'rollups', 'anomalyAlert', 'staticAlert', 'noDataAlert', 'isInfluencingEvents', 'notifyOnlyOpen', 'origin', 'channels', 'contacts', 'subscribers', 'dynamicRouting', 'alertActions', 'primaryAlertAction', 'pauseTime', 'paused', 'connectedTiles', 'alertTags', 'noDataDuration', 'eventsFilter', 'conditions', 'updatePolicy', 'expressionTreeModel', 'id', 'triggerCount', 'creationTime', 'lastModifiedTime', 'validation', 'regressors'];

var Alert = /*#__PURE__*/function () {
  function Alert(alert) {
    if (alert && alert.tag) {
      // Server Format
      var tag = alert.tag,
          data = _objectWithoutPropertiesLoose(alert, _excluded);

      defaultsDeep(this, data);
      this.tag = JSON.parse(tag);
    } else if (alert) {
      // Client Format
      var _data = alert.data,
          other = _objectWithoutPropertiesLoose(alert, _excluded2);

      defaultsDeep(this, _data);
      this.tag = _extends({}, other);
    } else {
      defaultsDeep(this, defaultEmptyAlert);
    }
  }

  var _proto = Alert.prototype;

  _proto.exportClientFormat = function exportClientFormat() {
    var _this = this;

    var res = {
      data: {}
    };
    tagProperties.forEach(function (tagProp) {
      res[tagProp] = _this.tag[tagProp];
    });
    dataProperties.forEach(function (dataProp) {
      res.data[dataProp] = _this[dataProp];
    });
    return res;
  };

  _proto.exportServerFormat = function exportServerFormat() {
    var _this2 = this;

    var res = {};
    dataProperties.forEach(function (dataProp) {
      res[dataProp] = _this2[dataProp];
    });
    res.tag = JSON.stringify(this.tag);
    return res;
  };

  Alert.doAlert = function doAlert() {
    console.error(1001);
    console.log(1);
  }
  /** **********************************************
   *  Getters/Setters of raw data
   * ********************************************* */
  ;

  _createClass(Alert, [{
    key: 'ownerId',
    get: function get() {
      return this._ownerId;
    },
    set: function set(ownerId) {
      this._ownerId = ownerId;
    }
  }, {
    key: 'title',
    get: function get() {
      return this._title;
    },
    set: function set(title) {
      this._title = title;
    }
  }, {
    key: 'story',
    get: function get() {
      return this._story;
    },
    set: function set(story) {
      this._story = story;
    }
  }, {
    key: 'severity',
    get: function get() {
      return this._severity;
    },
    set: function set(severity) {
      this._severity = severity;
    }
  }, {
    key: 'rollups',
    get: function get() {
      return this._rollups;
    },
    set: function set(rollups) {
      this._rollups = rollups;
    }
  }, {
    key: 'origin',
    get: function get() {
      return this._origin;
    },
    set: function set(origin) {
      this._origin = origin;
    }
  }, {
    key: 'channels',
    get: function get() {
      return this._channels;
    },
    set: function set(channels) {
      this._channels = channels;
    }
  }, {
    key: 'contacts',
    get: function get() {
      return this._contacts;
    },
    set: function set(contacts) {
      this._contacts = contacts;
    }
  }, {
    key: 'subscribers',
    get: function get() {
      return this._subscribers;
    },
    set: function set(subscribers) {
      this._subscribers = subscribers;
    }
  }, {
    key: 'dynamicRouting',
    get: function get() {
      return this._dynamicRouting;
    },
    set: function set(dynamicRouting) {
      this._dynamicRouting = dynamicRouting;
    }
  }, {
    key: 'alertActions',
    get: function get() {
      return this._alertActions;
    },
    set: function set(alertActions) {
      this._alertActions = alertActions;
    }
  }, {
    key: 'primaryAlertAction',
    get: function get() {
      return this._primaryAlertAction;
    },
    set: function set(primaryAlertAction) {
      this._primaryAlertAction = primaryAlertAction;
    }
  }, {
    key: 'pauseTime',
    get: function get() {
      return this._pauseTime;
    },
    set: function set(pauseTime) {
      this._pauseTime = pauseTime;
    }
  }, {
    key: 'paused',
    get: function get() {
      return this._paused;
    },
    set: function set(paused) {
      this._paused = paused;
    }
  }, {
    key: 'anomalyAlert',
    get: function get() {
      return this._anomalyAlert;
    },
    set: function set(anomalyAlert) {
      this._anomalyAlert = anomalyAlert;
    }
  }, {
    key: 'staticAlert',
    get: function get() {
      return this._staticAlert;
    },
    set: function set(staticAlert) {
      this._staticAlert = staticAlert;
    }
  }, {
    key: 'noDataAlert',
    get: function get() {
      return this._noDataAlert;
    },
    set: function set(noDataAlert) {
      this._noDataAlert = noDataAlert;
    }
  }, {
    key: 'notifyOnlyOpen',
    get: function get() {
      return this._notifyOnlyOpen;
    },
    set: function set(notifyOnlyOpen) {
      this._notifyOnlyOpen = notifyOnlyOpen;
    }
  }, {
    key: 'connectedTiles',
    get: function get() {
      return this._connectedTiles;
    },
    set: function set(connectedTiles) {
      this._connectedTiles = connectedTiles;
    }
  }, {
    key: 'alertTags',
    get: function get() {
      return this._alertTags;
    },
    set: function set(alertTags) {
      this._alertTags = alertTags;
    }
  }, {
    key: 'noDataDuration',
    get: function get() {
      return this._noDataDuration;
    },
    set: function set(noDataDuration) {
      this._noDataDuration = noDataDuration;
    }
  }, {
    key: 'eventsFilter',
    get: function get() {
      return this._eventsFilter;
    },
    set: function set(eventsFilter) {
      this._eventsFilter = eventsFilter;
    }
  }, {
    key: 'isInfluencingEvents',
    get: function get() {
      return this._isInfluencingEvents;
    },
    set: function set(isInfluencingEvents) {
      this._isInfluencingEvents = isInfluencingEvents;
    }
  }, {
    key: 'conditions',
    get: function get() {
      return this._conditions;
    },
    set: function set(conditions) {
      this._conditions = conditions;
    }
  }, {
    key: 'updatePolicy',
    get: function get() {
      return this._updatePolicy;
    },
    set: function set(updatePolicy) {
      this._updatePolicy = updatePolicy;
    }
  }, {
    key: 'expressionTreeModel',
    get: function get() {
      return this._expressionTreeModel;
    },
    set: function set(expressionTreeModel) {
      this._expressionTreeModel = expressionTreeModel;
    }
  }, {
    key: 'tag',
    get: function get() {
      return this._tag;
    },
    set: function set(tag) {
      this._tag = tag;
    } // only getters

  }, {
    key: 'id',
    get: function get() {
      return this._id;
    },
    set: function set(id) {
      this._id = id;
    }
  }, {
    key: 'triggerCount',
    get: function get() {
      return this._triggerCount;
    },
    set: function set(triggerCount) {
      this._triggerCount = triggerCount;
    }
  }, {
    key: 'creationTime',
    get: function get() {
      return this._creationTime;
    },
    set: function set(creationTime) {
      this._creationTime = creationTime;
    }
  }, {
    key: 'lastModifiedTime',
    get: function get() {
      return this._lastModifiedTime;
    },
    set: function set(lastModifiedTime) {
      this._lastModifiedTime = lastModifiedTime;
    }
  }, {
    key: 'validation',
    get: function get() {
      return this._validation;
    },
    set: function set(validation) {
      this._validation = validation;
    }
  }]);

  return Alert;
}();

export { Alert as default };